import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { StatusType } from "__generated__/enums";

const StatusTypeSelect = ({ value, onChange, disabled }: Omit<SelectProps<StatusType, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={[ StatusType.Call, StatusType.Cargo, StatusType.Voyage, StatusType.Declaration, StatusType.Invoice ]}
			getOptionLabel={option => intl.formatMessage({ id: `STATUS_${option}` })}
			value={value}
			onChange={onChange}
			disabled={disabled}
			clearable={false}
			disableSearch />
	);
};

export default StatusTypeSelect;
